import BaseModelInstance from './base.model'
import { LeaderReportCard as ModelDefinition } from './model-definitions'

class LeaderReportCard extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default LeaderReportCard
